/**
 * Simple client-side NLU for the chatbot to improve free-text understanding.
 */

const INTENT_RULES = [
    {
        intent: 'greeting',
        keywords: ['hallo', 'hi', 'moin', 'servus', 'guten tag', 'guten morgen', 'guten abend', 'hey'],
    },
    {
        intent: 'list_open_invoices',
        keywords: ['offen', 'unbezahlt', 'ausstehend', 'liste rechnungen', 'offene posten', 'was ist noch zu zahlen', 'unbezahlte'],
    },
    {
        intent: 'request_report',
        keywords: ['report', 'bericht', 'auswertung', 'bwa', 'pnl', 'guv', 'cashflow', 'liquidität', 'zahlen', 'umsatz', 'gewinn'],
    },
    {
        intent: 'create_invoice',
        keywords: ['erstellen', 'anlegen', 'neue rechnung', 'schreiben', 'neues angebot'],
        required: ['rechnung', 'angebot', 'auftrag'],
    },
    {
        intent: 'invoice_status',
        keywords: ['status', 'stand', 'prüfen', 'kontrollieren', 'bezahlt', 'erhalten'],
        required: ['rechnung'],
    },
    {
        intent: 'help_topic',
        keywords: ['hilfe', 'hilf', 'support', 'handbuch', 'anleitung', 'erklär', 'fehler', 'problem', 'geht nicht'],
    },
    {
        intent: 'help_faq',
        keywords: ['faq', 'frage', 'antwort', 'wissen', 'gewusst wie'],
    }
];

export function classifyIntent(text) {
    const lowerText = text.toLowerCase();
    
    for (const rule of INTENT_RULES) {
        const hasKeyword = rule.keywords.some(kw => lowerText.includes(kw));
        const hasRequired = !rule.required || rule.required.some(req => lowerText.includes(req));
        
        if (hasKeyword && hasRequired) {
            return {
                intent: rule.intent,
                confidence: 0.8,
                slots: extractSlots(lowerText, rule.intent)
            };
        }
    }
    
    return {
        intent: 'fallback',
        confidence: 1.0,
        slots: {}
    };
}

function extractSlots(text, intent) {
    const slots = {};
    
    if (intent === 'help_faq') {
        slots.query = text.replace(/faq|frage|antwort|wissen/g, '').trim();
    }
    
    if (intent === 'request_report') {
        if (text.includes('bwa')) slots.report_type = 'BWA';
        if (text.includes('pnl') || text.includes('guv')) slots.report_type = 'PNL';
        if (text.includes('cashflow') || text.includes('liquidität')) slots.report_type = 'CASHFLOW';
    }
    
    if (intent === 'help_topic') {
        if (text.includes('umsatzsteuer') || text.includes('steuer')) slots.topic = 'Umsatzsteuer';
        if (text.includes('rechnung')) slots.topic = 'Rechnungen';
        if (text.includes('ausgabe')) slots.topic = 'Ausgaben';
    }

    // Simple date extraction (YYYY-MM-DD or DD.MM.YYYY)
    const dateMatch = text.match(/(\d{4}-\d{2}-\d{2})|(\d{2}\.\d{2}\.\d{4})/);
    if (dateMatch) {
        slots.date = dateMatch[0];
    }

    // Simple UUID extraction for invoice_id
    const uuidMatch = text.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i);
    if (uuidMatch) {
        slots.invoice_id = uuidMatch[0];
    }

    return slots;
}
